<template>
  <!-- 调拨单详情（新增/编辑/查看） -->
  <div class="transfer-order-detail">
    <list-page :status-name="dataDetail.statusName" :status-type="dataDetail.status === 4001? 'info': 'success'">
      <div class="form-div">
        <form-tag label="单据信息"/>
        <form-items :columns="3" :data="dataDetail">
          <form-item label="单据编号">
            <el-input v-model="dataDetail.billNo" placeholder="系统自动生成" disabled/>
          </form-item>
          <form-item label="单据日期">
            <el-date-picker v-model="dataDetail.billDate" type="date" value-format="YYYY-MM-DD" placeholder="选择日期" style="width:100%"/>
          </form-item>
          <form-item label="出库仓库" :required="true" name="outWarehouseId" error-message="请选择出库仓库">
            <el-select v-model="dataDetail.outWarehouseId" placeholder="请选择出库仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="入库仓库" :required="true" name="inWarehouseId" error-message="请选择入库仓库">
            <el-select v-model="dataDetail.inWarehouseId" placeholder="请选择入库仓库">
              <el-option v-for="w in warehouseOptions" :key="w.id" :value="w.id" :label="w.warehouseName"/>
            </el-select>
          </form-item>
          <form-item label="操作员">
            <el-input v-model="dataDetail.operatorName" disabled/>
          </form-item>
          <form-item label="部门">
            <depart-select v-model="dataDetail.departCode" :data="departTree" :disabled="isReadonly || dataDetail.status === 4010" placeholder="请选择部门"/>
          </form-item>
          <form-item label="备注" :show-block="true">
            <el-input type="textarea" v-model="dataDetail.remark" placeholder="备注信息"/>
          </form-item>
        </form-items>
        <form-tag label="调拨明细（商品从出库仓库扣减，向入库仓库增加）"/>
      </div>
      <list-table class="list-table" background-color="#FFF">
        <product-select-table ref="itemTable" v-model="dataDetail.items" :multi="true" @table-select-multi="addList2Items">
          <yq-table-column label="批次" prop="batchNumber" width="160rem">
            <template v-slot="{row}">
              <span>{{row.batchNumber}}</span>
            </template>
          </yq-table-column>
          <yq-table-column label="数量" prop="qty" width="130rem">
            <template v-slot="{row}">
              <el-input-number v-model="row.qty" :min="1" controls-position="right" :disabled="isReadonly" style="width:100%"/>
            </template>
          </yq-table-column>
          <yq-table-column label="基本单位" width="100rem" align="center">
            <template v-slot="{row}">{{unitName(row.unitIdBase)}}</template>
          </yq-table-column>
          <yq-table-column label="操作" width="90rem" align="center" v-if="!isReadonly">
            <template v-slot="{row, $index}">
              <table-button el-type="danger" @click="deleteItem($index)">移除</table-button>
            </template>
            <template #header>
              <table-button :disabled="isReadonly" @click="addItem"><yq-icon name="element-ui_plus"/>添加商品</table-button>
            </template>
          </yq-table-column>
        </product-select-table>
      </list-table>

      <form-page :show-page="false" v-if="!isReadonly">
        <template #left>
          <div class="tip-info">
            💡 调拨不改变商品总体数量，仅仓库间转移；出/入库仓库可为同一仓库。
          </div>
        </template>
        <page-button :disabled="dataDetail.status > 4001" type="write" el-type="primary" @click="saveData">保存草稿</page-button>
        <page-button :disabled="dataDetail.status > 4001" type="write" el-type="success" @click="submitData">提交单据</page-button>
        <page-button @click="router.go(-1)">取消</page-button>
      </form-page>
    </list-page>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import PageButton from "@/components/h5/button/PageButton.vue";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqIcon from "@/components/YqIcon.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import ProductSelectTable from "@/components/h5/product/ProductSelectTable.vue";
import DepartSelect from "@/components/h5/data/DepartSelect.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import commonApi from "@/api/commonApi";
import transferOrderApi from "@/api/normal/stock/transferOrderApi";
import commonDataApi from "@/api/normal/common/commonDataApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "TransferOrderDetail",
  components: {
    YqIcon, ProductSelectTable, YqTableColumn, TableButton, FormItems, FormItem, FormTag,
    DepartSelect,
    PageButton, ListPage, ListTable, FormPage
  },
  data() {
    return {
      warehouseOptions: [],
      departTree: [],
      unitList: [],
      dataDetail: {},
      isReadonly: false,
      userInfo: {},
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  async created() {
    // 不使用页面缓存
    this.userInfo = await Util.getUserInfo();
    this.init();
    let id = this.route.query.id;
    if (id) {
      this.isReadonly = this.route.query.view === '1';
      await this.findById(id);
    } else {
      this.initNew();
    }
  },
  methods: {
    init() {
      // 仓库/单位下拉 + 部门树
      commonDataApi.queryAllWarehouse().then(warehouses => this.warehouseOptions = warehouses || []);
      commonApi.queryDepartList().then(departs => this.departTree = departs || []);
      commonApi.queryUniqueDictionaryList("PRODUCT_UNIT").then(units => this.unitList = units || []);
    },
    unitName(unitId) {
      if (!unitId) return "";
      let u = this.unitList.find(it => it.dictCode === unitId);
      return u ? u.dictName : "";
    },
    async findById(id) {
      const res = await transferOrderApi.findById(id);
      this.dataDetail = res;
      this.dataDetail.items = (res.itemList || []).map(it => ({
        skuId: it.skuId || it.productId,
        productId: it.productId,
        productName: it.productName || "",
        unitIdBase: it.unitIdBase || it.skuUnitId,
        skuUnitId: it.skuUnitId,
        qty: it.qty,
        batchId: it.batchId,
        batchNumber: it.batchNumber,
      }));
    },
    initNew() {
      this.dataDetail = {
        billNo: "", billDate: this.today(),
        outWarehouseId: "", inWarehouseId: "", remark: "",
        operatorId: this.userInfo ? this.userInfo.id : "",
        operatorName: this.userInfo ? this.userInfo.employeeName : "",
        departCode: this.userInfo ? this.userInfo.mainDepartCode : "",
        items: [{}],
      };

    },
    today() {
      return new Date().toISOString().slice(0, 10);
    },
    addItem() {
      if (!this.dataDetail.outWarehouseId) {
        this.$message.error("请先选择出库仓库");
        return;
      }
      this.$refs.itemTable.toSelectMore();
    },
    deleteItem(index) {
      this.dataDetail.items.splice(index, 1);
      this.$refs.itemTable.refresh();
    },
    // 添加商品：自动带出该商品在出库仓库的批次（FIFO），多批次拆多行
    async addList2Items(list) {
      debugger
      this.fillItems(this.dataDetail.items, list);
      const productIds = [];
      for (let j = 0; j < list.length; j++) {
        const pid = list[j].parentId || list[j].id;
        if (productIds.indexOf(pid) < 0) productIds.push(pid);
      }
      const batches = await transferOrderApi.queryStockBatchVoByProducts(this.dataDetail.outWarehouseId, productIds);
      const batchMap = {};
      (batches || []).forEach(b => {
        const key = b.productId || b.skuId;
        if (!batchMap[key]) batchMap[key] = [];
        batchMap[key].push(b);
      });
      const newItems = [];
      this.dataDetail.items.forEach(it => {
        const productBatches = batchMap[it.productId] || [];
        if (productBatches.length <= 1) {
          const batch = productBatches[0];
          if (batch) {
            it.batchId = batch.batchId;
            it.batchNumber = batch.batchNumber;
          }
          newItems.push(it);
        } else {
          // 多批次：按 FIFO 顺序拆成多行，每行一个批次
          productBatches.forEach(b => {
            newItems.push({
              skuId: it.skuId,
              productId: it.productId,
              productName: it.productName,
              unitIdBase: it.unitIdBase,
              skuUnitId: it.skuUnitId,
              qty: it.qty,
              batchId: b.batchId,
              batchNumber: b.batchNumber,
            });
          });
        }
      });
      this.dataDetail.items = newItems;
      this.$refs.itemTable.refresh();
    },
    fillItems(items, list) {
      for (let i = 0; i < items.length; i++) {
        for (let j = 0; j < list.length; j++) {
          if (items[i].skuId === list[j].id) {
            items[i].productId = list[j].parentId || list[j].id;
            items[i].productName = list[j].productName;
            items[i].unitIdBase = list[j].unitIdBase;
            items[i].skuUnitId = list[j].unitIdBase;
            items[i].qty = items[i].qty || 1;
          }
        }
      }
    },
    buildItemList() {
      return (this.dataDetail.items || []).filter(it => it.skuId).map(it => ({
        productId: it.productId || it.skuId,
        skuId: it.skuId,
        skuUnitId: it.skuUnitId || it.unitIdBase,
        qty: it.qty,
        batchId: it.batchId,
        batchNumber: it.batchNumber,
      }));
    },
    validate() {
      if (!this.dataDetail.outWarehouseId || !this.dataDetail.inWarehouseId) {
        this.$message.error("请选择出库/入库仓库");
        return false;
      }
      const items = this.buildItemList();
      if (items.length === 0) {
        this.$message.error("请添加调拨明细");
        return false;
      }
      return true;
    },
    saveData() {
      if (!this.validate()) return;
      const submitData = {...this.dataDetail, status: 4001, itemList: this.buildItemList()};
      transferOrderApi.save(submitData).then(() => this.router.push('/stock/transfer'));
    },
    submitData() {
      if (!this.validate()) return;
      // 保存并提交（出库仓库扣减/入库仓库增加）
      const submitData = {...this.dataDetail, status: 4010, itemList: this.buildItemList()};
      transferOrderApi.save(submitData).then(() => this.router.push('/stock/transfer'));
    }
  }
};
</script>

<style lang="scss" scoped>
.transfer-order-detail {
  height: 100%;
  .form-div{
    padding: 10px 10px 0 10px;
    background: #FFF;
  }
  .list-table {
    padding: 10px;
  }
  .tip-info {
    font-size: 12px;
    color: var(--el-color-primary);
  }
}
</style>
